import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AppoinmentSuccessPopupComponent } from './appoinment-success-popup/appoinment-success-popup.component';

@Component({
  selector: 'app-engage-request',
  templateUrl: './engage-request.component.html',
  styleUrls: ['./engage-request.component.scss']
})
export class EngageRequestComponent implements OnInit {
  ticketData: any;
  selectedDate: any;
  timeValue: any;
  isSubmitted: boolean;
  uploadedFileName: any;
  appoinmentsDetails: any;
  formdata: FormData;
  showLoader: boolean;
  constructor( public dialog: MatDialog, private _formBuilder: FormBuilder,private toastr: ToastrService, private httpClient: HttpClient) { }
  favoriteSeason: string;
  contactInfoForm: FormGroup;
  seasons: string[] = ['15 Mins', '30 Mins', '45 Mins'];
  timeArray = [];

  ngOnInit(): void {
    this.favoriteSeason = '15 Mins';
    this.selectedDate = new Date().toISOString();
    this.radioChange();
    this.formCreate();
  }

  radioChange() {
    console.log(this.favoriteSeason)
    this.timeArray = [];
    let fifteenMinTime = ['9:00 am', '9:15 am', '9:30 am','9:45 am','10:00 am', '10:15 am', '10:30 am','10:45 am',
    '11:00 am', '11:15 am', '11:30 am','11:45 am', '12:00 pm', '12:15 pm', '12:30 pm','12:45 pm',
    '01:00 pm', '01:15 pm', '01:30 pm','01:45 pm', '02:00 pm', '02:15 pm', '02:30 pm','02:45 pm',
    '03:00 pm', '03:15 pm', '03:30 pm','03:45 pm', '04:00 pm', '04:15 pm', '04:30 pm','04:45 pm',
    '05:00 pm', '05:15 pm', '05:30 pm','05:45 pm', '06:00 pm', '06:15 pm', '06:30 pm','06:45 pm',
    '07:00 pm', '07:15 pm', '07:30 pm','07:45 pm', '08:00 pm' ];

    let thirtyMinTime = ['9:00 am', '9:30 am','10:00 am', '10:30 am','11:00 am', '11:30 am',
     '12:00 pm', '12:30 pm', '01:00 pm',  '01:30 pm', '02:00 pm',  '02:30 pm', '03:00 pm', 
     '03:30 pm', '04:00 pm',  '04:30 pm', '05:00 pm',  '05:30 pm', '06:00 pm',  '06:30 pm',
    '07:00 pm', '07:30 pm', '08:00 pm' ];

    let fourtyfiveMinTime = ['9:00 am', '9:45 am', '10:30 am', '11:15 am', '12:00 pm', '12:45 pm',
    '01:30 pm', '02:15 pm', '03:00 pm', '03:45 pm', '04:30 pm', '05:15 pm', '06:00 pm', '06:45 pm',
    '07:30 pm'];

    if(this.favoriteSeason == '15 Mins') {
      this.timeArray = fifteenMinTime;
    } else if (this.favoriteSeason == '30 Mins') {
      this.timeArray = thirtyMinTime;
    } else {
      this.timeArray = fourtyfiveMinTime;
    }
    this.timeValue = this.timeArray[0];
  }

  timeTrigger(value) {
    this.timeValue = value;
  }

  onSelectDate(event){
    this.selectedDate = event;
    this.selectedDate = new Date(this.selectedDate).toISOString();
  }

  formCreate() {
    this.contactInfoForm = this._formBuilder.group({
      fullName: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(10), Validators.pattern(/^[0-9]+$/)]],
      email: ['', [Validators.required, Validators.email]],
      industry: ['', Validators.required],
      notes: ['', Validators.required],
      addFile: ['', Validators.required],
      notification: [false],
      fileName: ['']
    });
  }

  onFileSelected(fileInput) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(fileInput.target.files[0]);
      this.formdata = new FormData();
      this.formdata.append('attachement', fileInput.target.files[0]);
      this.contactInfoForm.patchValue({ fileName: fileInput.target.files[0].name })
    }
   }


  createAppointment() {   
    this.isSubmitted = true;
    if (this.contactInfoForm.invalid) {
      return false;
    } else {
      this.showLoader = true;
      this.formdata.append('category', this.contactInfoForm.get('industry').value);
      this.formdata.append('notes', this.contactInfoForm.get('notes').value);
      this.formdata.append('order_number', '');
      this.formdata.append('status', 'Yet to contact');
      this.formdata.append('name', this.contactInfoForm.get('fullName').value);
      this.formdata.append('phone_no', this.contactInfoForm.get('phoneNumber').value);
      this.formdata.append('email', this.contactInfoForm.get('email').value);
      this.formdata.append('date', this.selectedDate);
      this.formdata.append('time', this.timeValue);
      this.formdata.append('duration', this.favoriteSeason);
      this.formdata.append('notification', this.contactInfoForm.get('notification').value);

      this.httpClient.post<any>(`${environment.customerUrl}api/v1/conference`, this.formdata).subscribe((value) => {
        console.log(value)
        this.showLoader = false;
        this.appoinmentsDetails = value.conference_details;
        this.successPopupOpen(); 
      },
        error => {
          this.showLoader = false;
          this.toastr.error(error.error.message, 'Error');
        });


    }
  }

  resetForm() {
    this.favoriteSeason = '15 Mins';
    this.selectedDate = new Date().toISOString();
    this.contactInfoForm.reset();
    this.isSubmitted = false;
    this.formCreate();
    this.radioChange();
  }

  successPopupOpen() {
    const dialogRef = this.dialog.open(AppoinmentSuccessPopupComponent,
      {
        panelClass: 'my-panel',
        disableClose: true,
        data: { data: this.appoinmentsDetails }
      });

    dialogRef.afterClosed().subscribe(
      res => {
        if(res) {
          if(res.data == 'Confirm') {
            this.resetForm();
          }
        }     
      }
    )
  }

}
